import { deviceTypes } from 'z-js-commons';

export default {
    info: {
        title: "L'ARCHIVIO DELLE TUE VERIFICHE",
        description: 'Qui ritrovi le verifiche che hai creato o modificato, dalla più recente. Puoi modificarle ancora o esportarle.',
        name: 'TeacherHomeworkNavItem',
        tutorialName: 'archivio_tab-verifiche'
    },
    [deviceTypes.DESKTOP]: {
        popoverPlacement: 'right',
        xPlacement: 'LEFT',
        yPlacement: 'MIDDLE',
        xOffset: 10,
        yOffset: 0
    },
    [deviceTypes.PHONE]: {
        popoverPlacement: 'right',
        xPlacement: 'LEFT',
        yPlacement: 'MIDDLE',
        xOffset: 10,
        yOffset: 0
    }
};
